import { render } from "./CompRelatorios.vue?vue&type=template&id=a51d432c&scoped=true"
import script from "./CompRelatorios.vue?vue&type=script&lang=js"
export * from "./CompRelatorios.vue?vue&type=script&lang=js"

import "./CompRelatorios.vue?vue&type=style&index=0&id=a51d432c&scoped=true&lang=css"
import "./CompRelatorios.vue?vue&type=style&index=1&id=a51d432c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a51d432c"]])

export default __exports__